import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';
import { companyCaptablesByIdStateJ } from '../../../../../services/state/CapTableDataStateJ';
import { currentScenarioStateJ } from '../../../../../services/state/ScenariosStateJ';
import { selectedCompanyIdProfileAtom } from '../../../state/UIStateJ';
import { getCaptableById } from '../../../../../services/queries/MaggieCapTableQueries';

export function useScenarioCaptableData() {
  const currentScenario = useAtomValue(currentScenarioStateJ);
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const captablesById = useAtomValue(companyCaptablesByIdStateJ(companyId));
  const [captable, setCaptable] = useState(() => captablesById.get(currentScenario?.captableId ?? 0) ?? null);
  const [loading, setLoading] = useState(!captable && !!currentScenario?.captableId);

  useEffect(() => {
    if (captable || !currentScenario) {
      return;
    }
    // A new scenario for a company with no primary cap table has no captableId — nothing to fetch.
    if (!currentScenario.captableId) {
      setLoading(false);
      return;
    }
    getCaptableById(currentScenario.captableId)
      .then((ct) => {
        setCaptable(ct ?? null);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [captable, currentScenario]);

  return { captable, setCaptable, loading };
}
